import { render, staticRenderFns } from "./ModalTeacherPrimaryInfo.vue?vue&type=template&id=767eb70e&scoped=true&"
import script from "./ModalTeacherPrimaryInfo.vue?vue&type=script&lang=js&"
export * from "./ModalTeacherPrimaryInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalTeacherPrimaryInfo.vue?vue&type=style&index=0&id=767eb70e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767eb70e",
  null
  
)

export default component.exports